export const SEARCH_PARAMS_TAB_KEY = 'tab'

/** Hardcoded tab ID for the Base Photos timeline - not customizable */
export const BASE_PHOTOS_TAB_ID = 'base-photos'

export const BASE_PHOTOS_TAB_LABEL = 'Photos'

/** Hardcoded tab ID for the PreTrip tab (same content as Volunteers Groups PreTrip) */
export const BASE_PRETRIP_TAB_ID = 'pretrip'

export const BASE_PRETRIP_TAB_LABEL = 'PreTrip'

/** Hardcoded tab ID for Hub About videos */
export const BASE_ABOUT_TAB_ID = 'tutorials'

export const BASE_ABOUT_TAB_LABEL = 'Tutorials'

/** Previous Hub About tab query value; still opens Tutorials. */
export const BASE_ABOUT_TAB_ID_LEGACY = 'about'

/** Permanent configurable tab for Admin/Base Leader only */
export const BASE_AR_TAB_ID = 'ar'

export const BASE_AR_TAB_LABEL = 'AR'

export const BASE_HARDCODED_TAB_IDS = [
  BASE_PHOTOS_TAB_ID,
  BASE_PRETRIP_TAB_ID,
  BASE_ABOUT_TAB_ID,
  BASE_ABOUT_TAB_ID_LEGACY,
  BASE_AR_TAB_ID,
] as const
